import Table from './views/Table.c';
export default Table;
